
    <template>
    <svg viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg">
<path d="M16.25 16.7158H0.5V2.58105H5.36698V3.75895H1.71154V15.5379H15.0385V3.75895H11.4247V2.58105H16.25V16.7158Z" fill="currentColor"/>
<path d="M8.32806 10.7951L8.39611 10.8612L8.46416 10.7951L10.9668 8.36372L11.6824 9.05943L8.39611 12.2545L5.10982 9.05943L5.8254 8.36372L8.32806 10.7951Z" fill="currentColor" stroke="currentColor" stroke-width="0.195312"/>
<path d="M7.78906 10.978V0.96582H9.0006V10.978H7.78906Z" fill="currentColor"/>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'Download',
    }) as DefineComponent
    </script>
    